module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('brand-logo', {
    attrs: {
      "large": ""
    }
  }), _vm._v(" "), _c('summoner-search', {
    attrs: {
      "center": "",
      "large": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "brand-lead"
  }, [_vm._v("\n        League of Legends League Points Tracker\n    ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d13aeb6a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/LandingPage.vue
// module id = 410
// module chunks = 1